import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MetadataEffects } from './metadata.effects';
import * as fromMetadatas from './metadata.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(fromMetadatas.featureKey, fromMetadatas.reducer),
    EffectsModule.forFeature(MetadataEffects),
  ],
})
export class MetadataStateModule {}
